var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404Dark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 342,
    viewBox: "0 0 367 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8081 34.9495H88.1464V96.2209V97.1705H89.0959H99.6451V116.106H89.0959H88.1464V117.055V134.406H66.0664V117.055V116.106H65.1168H18.9495V97.9267L62.8081 34.9495ZM67.7491 60.465V57.298L66.0067 59.9426L42.4482 95.6985L41.4784 97.1705H43.2412H66.7996H67.7491V96.2209V60.465Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.597 52.5921L177.601 52.5972C183.458 59.9384 186.987 70.4281 188.092 84.1713C189.211 98.0782 187.409 109.076 182.801 117.258L182.798 117.264C178.336 125.316 170.404 129.872 158.761 130.808C147.12 131.744 138.519 128.519 132.747 121.286C126.969 113.939 123.472 103.366 122.354 89.4582C121.248 75.7144 123.016 64.7976 127.546 56.6202C132.088 48.5576 140.063 43.9991 151.704 43.0628C163.348 42.1264 171.905 45.3561 177.597 52.5921ZM142.766 101.722L142.767 101.726C143.728 105.345 145.316 108.301 147.565 110.543L147.578 110.556L147.591 110.568C150.021 112.811 153.328 113.696 157.359 113.372C161.387 113.048 164.481 111.649 166.444 109.038C168.391 106.458 169.531 103.278 169.902 99.5434L169.902 99.5397C170.259 95.789 170.211 91.1529 169.768 85.645C169.11 77.4666 167.713 71.1539 165.518 66.7854C164.377 64.4806 162.751 62.7672 160.632 61.7037C158.523 60.6453 155.997 60.2664 153.107 60.4989C150.216 60.7314 147.784 61.509 145.871 62.8908C143.949 64.2794 142.617 66.2306 141.86 68.688C140.391 73.3512 140.02 79.8061 140.678 87.9845C141.121 93.4924 141.814 98.0767 142.766 101.722Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.616 68.0358L289.829 75.504L271.77 134.054L271.49 134.961L272.397 135.241L282.478 138.35L276.897 156.444L266.816 153.335L265.909 153.055L265.629 153.962L260.515 170.542L239.416 164.034L244.53 147.454L244.81 146.547L243.902 146.267L199.786 132.66L205.144 115.289L265.616 68.0358ZM262.817 93.8742L263.751 90.8478L261.306 92.8614L228.255 120.085L226.895 121.206L228.579 121.726L251.091 128.669L251.999 128.949L252.278 128.042L262.817 93.8742Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.5 149L85.8225 149C82.3263 149 79.4922 151.834 79.4922 155.33V283.127C79.4922 286.624 82.3263 289.458 85.8225 289.458H302.22C305.717 289.458 308.551 286.624 308.551 283.127V155.33C308.551 151.834 305.717 149 302.22 149H289",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_1177_39807",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.612 182.799C171.14 180.327 167.132 180.327 164.66 182.799L157.348 190.111C154.876 192.583 154.876 196.591 157.348 199.063L177.62 219.335L157.346 239.609C154.874 242.081 154.874 246.089 157.346 248.561L164.657 255.872C167.13 258.344 171.138 258.344 173.61 255.872L193.884 235.598L214.157 255.871C216.629 258.344 220.637 258.344 223.109 255.871L230.42 248.56C232.893 246.088 232.893 242.08 230.42 239.608L210.147 219.335L230.418 199.064C232.89 196.592 232.89 192.583 230.418 190.111L223.107 182.8C220.635 180.328 216.627 180.328 214.155 182.8L193.884 203.071L173.612 182.799Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.66 182.799L166.002 184.142L164.66 182.799ZM173.612 182.799L174.955 181.457V181.457L173.612 182.799ZM157.348 190.111L158.691 191.453L157.348 190.111ZM157.348 199.063L156.006 200.406H156.006L157.348 199.063ZM177.62 219.335L178.963 220.678L180.306 219.335L178.963 217.992L177.62 219.335ZM157.346 239.609L158.689 240.952H158.689L157.346 239.609ZM157.346 248.561L156.003 249.904L156.003 249.904L157.346 248.561ZM164.657 255.872L163.315 257.215H163.315L164.657 255.872ZM173.61 255.872L174.953 257.215L173.61 255.872ZM193.884 235.598L195.227 234.255L193.884 232.912L192.541 234.255L193.884 235.598ZM214.157 255.871L215.5 254.529V254.529L214.157 255.871ZM230.42 239.608L229.078 240.951H229.078L230.42 239.608ZM210.147 219.335L208.804 217.992L207.462 219.335L208.804 220.678L210.147 219.335ZM230.418 199.064L229.075 197.721L229.075 197.721L230.418 199.064ZM230.418 190.111L229.075 191.454L229.075 191.454L230.418 190.111ZM223.107 182.8L221.764 184.143V184.143L223.107 182.8ZM193.884 203.071L192.541 204.414L193.884 205.757L195.227 204.414L193.884 203.071ZM166.002 184.142C167.733 182.412 170.539 182.412 172.269 184.142L174.955 181.457C171.741 178.243 166.53 178.243 163.317 181.457L166.002 184.142ZM158.691 191.453L166.002 184.142L163.317 181.457L156.006 188.768L158.691 191.453ZM158.691 197.72C156.961 195.99 156.961 193.184 158.691 191.453L156.006 188.768C152.792 191.981 152.792 197.192 156.006 200.406L158.691 197.72ZM178.963 217.992L158.691 197.72L156.006 200.406L176.277 220.678L178.963 217.992ZM158.689 240.952L178.963 220.678L176.277 217.992L156.003 238.266L158.689 240.952ZM158.689 247.218C156.959 245.488 156.959 242.682 158.689 240.952L156.003 238.266C152.79 241.48 152.79 246.69 156.003 249.904L158.689 247.218ZM166 254.529L158.689 247.218L156.003 249.904L163.315 257.215L166 254.529ZM172.267 254.529C170.536 256.26 167.731 256.26 166 254.529L163.315 257.215C166.528 260.429 171.739 260.429 174.953 257.215L172.267 254.529ZM192.541 234.255L172.267 254.529L174.953 257.215L195.227 236.941L192.541 234.255ZM215.5 254.529L195.227 234.255L192.541 236.941L212.814 257.214L215.5 254.529ZM221.767 254.529C220.036 256.259 217.23 256.259 215.5 254.529L212.814 257.214C216.028 260.428 221.238 260.428 224.452 257.214L221.767 254.529ZM229.078 247.217L221.767 254.529L224.452 257.214L231.763 249.903L229.078 247.217ZM229.078 240.951C230.808 242.681 230.808 245.487 229.078 247.217L231.763 249.903C234.977 246.689 234.977 241.479 231.763 238.265L229.078 240.951ZM208.804 220.678L229.078 240.951L231.763 238.265L211.49 217.992L208.804 220.678ZM229.075 197.721L208.804 217.992L211.49 220.678L231.761 200.407L229.075 197.721ZM229.075 191.454C230.806 193.185 230.806 195.99 229.075 197.721L231.761 200.407C234.975 197.193 234.975 191.982 231.761 188.768L229.075 191.454ZM221.764 184.143L229.075 191.454L231.761 188.768L224.45 181.457L221.764 184.143ZM215.498 184.143C217.228 182.413 220.034 182.413 221.764 184.143L224.45 181.457C221.236 178.244 216.026 178.244 212.812 181.457L215.498 184.143ZM195.227 204.414L215.498 184.143L212.812 181.457L192.541 201.728L195.227 204.414ZM172.269 184.142L192.541 204.414L195.227 201.728L174.955 181.457L172.269 184.142Z",
    fill: "#807ED2",
    mask: "url(#path-5-inside-1_1177_39807)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter5_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.05 37.5C204.05 42.2713 200.398 46.0505 196 46.0505C191.602 46.0505 187.95 42.2713 187.95 37.5C187.95 32.7287 191.602 28.9495 196 28.9495C200.398 28.9495 204.05 32.7287 204.05 37.5Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 322.5,
    cy: 121.5,
    r: 12.5505,
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter7_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.637 305.956L343.485 305.548L348.263 313.006L344.193 320.873L335.345 321.281L330.567 313.823L334.637 305.956Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter8_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.637 187.246L38.2765 179.701L47.1304 179.946L51.3449 187.737L46.7055 195.282L37.8515 195.036L33.637 187.246Z",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter9_d_1177_39807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.945,
    y: 16.1629,
    width: 30.053,
    height: 30.053,
    transform: "rotate(15 226.945 16.1629)",
    stroke: "#807ED2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1177_39807",
    x: 0.908258,
    y: 19.4404,
    width: 116.778,
    height: 135.539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1177_39807",
    x: 103.993,
    y: 27.3959,
    width: 102.463,
    height: 124.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1177_39807",
    x: 181.507,
    y: 52.4228,
    width: 126.601,
    height: 138.931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1177_39807",
    x: 61.4509,
    y: 133.491,
    width: 265.141,
    height: 176.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1177_39807",
    x: 138.4,
    y: 166.386,
    width: 110.966,
    height: 110.964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1177_39807",
    x: 169.908,
    y: 13.4404,
    width: 52.1835,
    height: 53.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1177_39807",
    x: 291.908,
    y: 93.4404,
    width: 61.1835,
    height: 61.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1177_39807",
    x: 312.38,
    y: 290.015,
    width: 54.0698,
    height: 51.8646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1177_39807",
    x: 15.4493,
    y: 164.177,
    width: 54.0834,
    height: 51.6932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1177_39807",
    x: 200.912,
    y: 0.440368,
    width: 73.3165,
    height: 73.3168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39807",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404Dark);
export default __webpack_public_path__ + "static/media/error-404-dark.64353a6b667c8a35d50a6c81c7e5fa23.svg";
export { ForwardRef as ReactComponent };